// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3vv2U","content":"GlobalSearch_content__2Vnue"};